import BaseService from '../BaseService';

class IpService {
    constructor(instance) {
        this.instance = instance;
        this.base = new BaseService(this.instance);
    }

    getResults = (params, headers) => {
        return this.base.get(`/ip/${params.address}`, headers);
    }
}

export default IpService;
